import { Component } from 'react';


export default class AudioPlay extends Component {

  static defaultProps = {
    audioUrl: 'https://cine-books.com/sound/bell-notification.mp3'
  }

  constructor(props) {
    super(props);
    this.audio = new Audio(props.audioUrl);
  }

  componentDidUpdate(prevProps) {
    const {
      soundEnabled,
      activeFrame
    } = this.props;
    // check if slide has been changed - play the sound
    if (soundEnabled && activeFrame !== prevProps.activeFrame && activeFrame > 0) {
      this.playAudio();
    }
  }

  playAudio() {
    this.audio.currentTime = 0;
    this.audio.play();
  }

  render = () => null;
}



// WEBPACK FOOTER //
// ./src/components/BellPlay.jsx